<template>
  <v-container class="checklist" fluid>
    <v-row>
      <v-col cols="12" class="body-2 grey--text text-left pb-0">
        <div>
          <v-breadcrumbs :items="routeItems" divider=">"></v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 title">
        Serie: {{ $route.query.machineSerie }}
        <span class="caption"
          >{{ $route.query.event }}({{ $route.query.inputOuput }})</span
        >
        <p class="ma-0">
          Orden:
          <span class="font-weight-regular">{{ $route.query.order }}</span>
        </p>
        <p>
          Pedido:
          <span class="font-weight-regular">
            {{ $route.query.saleOrderID }}</span
          >
        </p>
      </v-col>
    </v-row>
    <prosic-state-images
      :isEditChecklist="isEditChecklist"
      :machineI="null"
      :checklistPhysicalI="null"
      :accessToEdit="accessToEdit"
    ></prosic-state-images>
    <ProsicVideos
      :isEditChecklist="isEditChecklist"
      :accessToEdit="accessToEdit"
    />
    <v-expansion-panels focusable>
      <v-expansion-panel
        v-for="(checklist, index) in checklistArray"
        :key="index"
        :readonly="!checklist.incidence && !isEditChecklist"
      >
        <v-expansion-panel-header
          :disabled="checklist.notApply || accessToEdit"
          class="pa-0 checklist-item"
          :class="
            checklist.checked
              ? 'expansion-panel-header--active'
              : 'expansion-panel-header'
          "
        >
          <v-container fluid class="pa-0" v-if="isEditChecklist">
            <v-row v-if="!checklist.notApply" no-gutters>
              <v-col
                align-self="center"
                class="px-1 py-4 checklist-item__not-apply text-center"
                cols="2"
                md="1"
                @click="
                  checklist.notApply = notApplyValidate(checklist.notApply)
                "
                >No aplica</v-col
              >

              <v-col cols="1" md="1" class="pl-2" align-self="center">
                <v-checkbox
                  :disabled="accessToEdit"
                  align-self="center"
                  hide-details
                  class="mt-1 mb-1 checklist-item__checkbox"
                  :ripple="false"
                  off-icon="radio_button_unchecked"
                  on-icon="radio_button_checked"
                  dense
                  @click.native.stop
                  height="0"
                  :input-value="checklist.checked"
                  :color="checklist.incidence ? 'accent' : 'primary'"
                ></v-checkbox>
              </v-col>
              <v-col align-self="center" class="pa-3" cols="8" md="10">
                {{ checklist.title }}
              </v-col>
              <v-col align-self="center" cols="1">
                <v-icon color="accent" small>fas fa-plus</v-icon>
              </v-col>
            </v-row>
            <v-row class="pa-3" v-else no-gutters>
              <v-col
                align-self="center"
                class="pa-2"
                cols="11"
                md="11"
                @click.stop="checklist.notApply = !checklist.notApply"
                align="center"
                >No aplica este componente en este modelo</v-col
              >
              <v-col align-self="center" align="center" cols="1" md="1">
                <v-icon
                  class="checklist-item__icon"
                  color="gray"
                  dense
                  size="16"
                  @click.stop="checklist.notApply = !checklist.notApply"
                  >fas fa-plus</v-icon
                >
              </v-col>
            </v-row>
          </v-container>
          <v-container fluid class="pa-0" v-else>
            <v-row v-if="!checklist.notApply" no-gutters>
              <v-col cols="1" md="1" class="pl-2" align-self="center">
                <v-checkbox
                  align-self="center"
                  hide-details
                  class="mt-1 mb-1 checklist-item__checkbox"
                  :ripple="false"
                  off-icon="radio_button_unchecked"
                  on-icon="radio_button_checked"
                  dense
                  @click.native.stop
                  height="0"
                  :input-value="true"
                  :disabled="checklist.incidence != true"
                  :color="checklist.incidence == true ? 'accent' : 'primary'"
                ></v-checkbox>
              </v-col>
              <v-col align-self="center" class="pa-3" cols="8" md="10">
                {{ checklist.title }}
              </v-col>
              <v-col cols="3" class="text-right pr-4 pt-2">
                <v-icon color="accent" small v-if="checklist.incidence == true"
                  >fas fa-plus</v-icon
                >
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="!checklist.notApply">
          <prosic-check-item
            :name="checklist.checklistName"
            :title="checklist.title"
            :isEditChecklist="isEditChecklist"
            :indexCheck="index"
            :descriptionCheck="checklist.description"
            :images="checklist.images"
            v-model="checklist.checked"
          ></prosic-check-item>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <ProsicFuelComponent
      :isEditChecklist="isEditChecklist"
      :accessToEdit="accessToEdit"
    />
    <ProsicHorometroComponent
      :isEditChecklist="isEditChecklist"
      :accessToEdit="accessToEdit"
    />
    <div class="checklist-review" v-if="isEditChecklist && invalidStatusReview">
      <v-col class="text-xs-left pa-1"
        >Seleccione la razon del nuevo estatus del checklist</v-col
      >
      <v-radio-group v-model="checklistStatusReview" class="mt-1">
        <v-radio
          v-for="check in statusReview"
          :key="check"
          :label="check"
          :value="check"
        ></v-radio>
      </v-radio-group>
    </div>
    <div class="checklist-review" v-else>
      <v-col class="text-xs-left pa-1"
        >Razon del nuevo estatus del checklist</v-col
      >
      <v-radio-group v-model="checklistStatusReview" class="mt-1" disabled>
        <v-radio
          v-for="check in statusReview"
          :key="check"
          :label="check"
          :value="check"
        ></v-radio>
      </v-radio-group>
    </div>
    <ProsicAddComponent v-if="isEditChecklist" :accessToEdit="accessToEdit" />
    <ProsicNotificationShare
      :accessToEdit="accessToEdit"
      :isEditChecklist="isEditChecklist"
    />
    <ProsicSignComponent
      :isEditChecklist="isEditChecklist"
      v-if="!isEditChecklist"
    />
    <ProsicShareButton
      buttonTitle="COMPARTIR CHECKLIST"
      v-if="!isEditChecklist"
    />
    <v-row v-if="isEditChecklist">
      <v-col cols="12">
        <v-checkbox
          :disabled="accessToEdit"
          v-model="termsAndConditions"
          align-self="center"
          hide-details
          class="mt-1 mb-1"
          :ripple="false"
          off-icon="radio_button_unchecked"
          on-icon="radio_button_checked"
          dense
          height="0"
        >
          <span slot="label">
            <a class="underline" @click="goContract()">
              <u>He leído</u>
            </a>
            y acepto los términos y condiciones de contrato.
          </span>
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="isEditChecklist" justify="end">
      <v-col cols="12" md="4">
        <v-btn
          :disabled="validFields"
          block
          class="black--text"
          color="accent"
          @click="signChecklist()"
          >completar guardado</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-else justify="end">
      <v-col cols="12" md="4">
        <v-btn block class="black--text" color="accent" @click="goBack()"
          >regresar</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ActualStateImages from "@/components/damage/item/ActualStateImages";
import { showMessage } from "@/services/MessageService";
import CheckItem from "@/components/damage/checklist/CheckItem";
import AddComponent from "@/components/damage/checklist/AddComponent";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import FuelComponent from "@/components/damage/checklist/FuelComponent";
import SignComponent from "@/components/damage/checklist/SignComponent";
import ShareButton from "@/components/damage/checklist/ShareButton";
import HorometroComponent from "@/components/damage/checklist/Horometro";
import Notification from "@/components/damage/checklist/Notification";
import ProsicVideos from "@/components/damage/checklist/ProsicVideos";

export default {
  data() {
    return {
      checklistID: this.$route.params.id,
      checklistEvent: this.$route.params.event,
      checklistType: this.$route.params.type,
      checklistProductID: this.$route.params.productID,
      statusID: this.$route.query.statusID,
      termsAndConditions: false,
      accessToEdit: false,
      firebaseOnSnapshot: null,
      checklistStatusReview: null,
      statusReview: [
        "Transporte Externo",
        "Retiro de equipo fuera de horario laboral",
        "Entrega de equipo fuera del horario laboral"
      ]
    };
  },
  async beforeMount() {
    this.resetFuelData();
    this.getUserAccess();
    // :: call to actions
    if (this.$route.query.typeAction === "consult") {
      this.firebaseOnSnapshot = await this.getChecklistRefData({
        checklistID: this.checklistID,
        checklistProductID: this.checklistProductID,
        checklistEvent: this.checklistEvent,
        checklistType: this.checklistType
      });
      this.firebaseOnSnapshot.onSnapshot(checklists => {
        checklists.forEach(checklist => {
          this.setInvalidStatus(checklist.data());
          this.updateStateChecklistConsult(checklist.data());
        });
      });
    }
  },
  computed: {
    ...mapState("user", ["userAccess", "data"]),
    ...mapState("checklist", [
      "checklistArray",
      "horometro",
      "checklistPhysicalImages",
      "machineImages",
      "validEmailNotifications"
    ]),
    isEditChecklist() {
      if (this.$route.query.typeAction === "save") return true;
      return false;
    },
    validFields() {
      const validImages = this.machineImages.find(o => o.src != null);
      const validHorometro =
        (this.horometro.value && this.horometro.image) ||
        this.horometro.notApply;
      const invalidCheckStatus = this.$route.query.invalidStatus
        ? this.checklistStatusReview !== null
        : true;
      if (
        this.termsAndConditions &&
        validImages &&
        validHorometro &&
        this.checklistPhysicalImages.src &&
        invalidCheckStatus &&
        this.validEmailNotifications
      )
        return false;
      return true;
    },
    invalidStatusReview() {
      return this.$route.query.invalidStatus;
    },
    routeItems() {
      const routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        path += element + "/";
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      routeItems.pop();
      return routeItems;
    }
  },
  components: {
    ProsicCheckItem: CheckItem,
    ProsicStateImages: ActualStateImages,
    ProsicAddComponent: AddComponent,
    ProsicFuelComponent: FuelComponent,
    ProsicHorometroComponent: HorometroComponent,
    ProsicSignComponent: SignComponent,
    ProsicShareButton: ShareButton,
    ProsicNotificationShare: Notification,
    ProsicVideos: ProsicVideos
  },
  methods: {
    ...mapActions("checklist", [
      "getChecklistRefData",
      "saveChecklist",
      "updateStateChecklistConsult",
      "resetChecklist",
      "analyticsReport",
      "analyticsReportIncidence",
      "resetFuelData"
    ]),
    ...mapActions("user", ["updatesLogs"]),
    goContract() {
      let routeData = this.$router.resolve({ name: "contrato" });
      window.open(routeData.href, "_blank");
    },

    async signChecklist() {
      loaderStart();
      const path = this.$route.fullPath.replace(
        "typeAction=save",
        "typeAction=consult"
      );
      const data = {
        id: this.checklistID,
        productID: this.checklistProductID,
        eventType: this.checklistEvent,
        checklistType: this.checklistType,
        statusID: this.statusID,
        orderId: this.$route.query.order,
        path: `${process.env.VUE_APP_URL}${path}`,
        correctStatus: this.$route.query.correctStatus,
        invalidChecklistStatus: this.checklistStatusReview
      };
      const { checklistPath } = await this.saveChecklist(data);
      // :: Analytics
      const analyticsReport = {
        eventType: this.checklistEvent,
        statusType: this.checklistType,
        orderID: this.checklistID,
        productID: this.checklistProductID,
        userUid: this.data.uid,
        machineSerie: this.$route.query.machineSerie || null
      };
      const checklistIncidence = [];
      for (let i = 0; i < this.checklistArray.length; i++) {
        const checklist = this.checklistArray[i];
        if (checklist.incidence) {
          checklistIncidence.push({
            index: i,
            name: checklist.checklistName,
            title: checklist.title,
            orderID: this.checklistID,
            productID: this.checklistProductID,
            statusType: this.checklistType,
            eventType: this.checklistEvent
          });
          analyticsReport.incidence = true;
        }
      }
      this.updatesLogs("save-checklist");
      this.analyticsReport(analyticsReport);
      this.analyticsReportIncidence(checklistIncidence);

      showMessage({
        message: "La información se guardo correctamente",
        color: "success"
      });
      this.goToSign(checklistPath);
      loaderDone();
    },
    goBack() {
      this.$router.push({
        path: this.$route.query.backUrlSearch
      });
    },
    goToSign(checklistPath) {
      const path = this.$route.fullPath.replace(
        "typeAction=save",
        "typeAction=consult"
      );
      const routerName =
        this.checklistEvent === "delivery" && this.checklistType === "output"
          ? "signChecklistTransportist"
          : "signChecklistReceptor";
      this.$router.push({
        name: routerName,
        params: {
          type: this.checklistType,
          step: 1,
          eventType: this.checklistEvent
        },
        query: {
          checklistPath,
          path: path
        }
      });
    },
    notApplyValidate(value) {
      if (this.accessToEdit) return;
      return !value;
    },
    getUserAccess() {
      if (this.$route.params.event == "delivery") {
        if (this.userAccess["damage-write-delivery"]) this.accessToEdit = false;
        else this.accessToEdit = true;
      }

      if (this.$route.params.event == "maintenance") {
        if (this.userAccess["damage-write-maintenance"])
          this.accessToEdit = false;
        else this.accessToEdit = true;
      }

      if (this.$route.params.event == "recollection") {
        if (this.userAccess["damage-write-recollection"])
          this.accessToEdit = false;
        else this.accessToEdit = true;
      }

      if (this.$route.params.event == "relocation") {
        if (this.userAccess["damage-write-relocation"])
          this.accessToEdit = false;
        else this.accessToEdit = true;
      }

      if (this.$route.params.event == "rented-service") {
        if (this.userAccess["damage-write-rentedservice"])
          this.accessToEdit = false;
        else this.accessToEdit = true;
      }
    },
    setInvalidStatus(data) {
      if (data) {
        this.checklistStatusReview = data.invalidChecklistStatus;
      }
    }
  },
  beforeDestroy() {
    this.resetChecklist();
    this.resetFuelData();
  }
};
</script>
<style scoped>
.checklist-item {
  min-height: auto;
}
.checklist-item__not-apply {
  background-color: lightgray;
}
.checklist-item__border {
  border: 1px solid black;
}
.checklist-item__icon {
  padding: 0;
  margin: 0;
  transform: rotate(45deg);
}
.checklist-review {
  border: 0.3px solid #a0a0a0;
  margin-top: 10px;
  padding-left: 5px;
}
</style>
